<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom policies-overview-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <preamble-block
      :title="title"
      :preamble="preamble"
      align="left"
    />

    <div
      v-if="firstNavigatablePages.length"
      class="overview-navigation-block__area"
    >
      <sub-heading :heading="navigatonalBlockTitle" />
      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div :class="rowClass">
          <overview-navigation-block
            v-for="(item, index) in firstNavigatablePages"
            :key="'overviewNavigationBlock--' + item.url + index"
            v-no-edit
            :style="{ animationDelay: ( index * (1 / 10)) + 's' }"
            :display-as-primary="displayFirstPuffAsPrimary && index === 0"
            v-bind="item"
            class="fade-in-up col"
            display-style="large"
          />
        </div>
      </in-view>
    </div>

    <div
      v-if="secondNavigatablePages.length"
      class="overview-navigation-block__area no-margin-bottom"
    >
      <sub-heading :heading="secondNavigatonalBlockTitle" />
      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div :class="secondRowClass">
          <overview-navigation-block
            v-for="(item, index) in secondNavigatablePages"
            :key="'overviewNavigationBlock--' + item.url + index"
            v-no-edit
            :style="{ animationDelay: ( index * (1 / 10)) + 's' }"
            :display-as-primary="displayFirstPuffAsPrimary && index === 0"
            v-bind="item"
            class="fade-in-up col"
            display-style="small"
          />
        </div>
      </in-view>
    </div>

    <div
      v-if="contactblocks.length"
      v-edit="'Contactblocks'"
      class="contact-blocks-wrapper"
    >
      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          class="row-1-noGutter-center_md-3 margin-gutter"
        >
          <contact-block
            v-for="(item,index) in contactblocks"
            :key="index"
            v-bind="item"
            class="col"
          />
        </div>
      </in-view>
    </div>

    <div
      v-if="accordionBlocks.length || (isEditable && accordionBlocks.length)"
      class="accordion-block-wrapper"
    >
      <sub-heading
        v-if="accordionsHeading || isEditable"
        :v-edit-heading="'AccordionsHeading'"
        :heading="accordionsHeading"
      />

      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          v-edit="'AccordionBlocks'"
        >
          <accordion-group
            :items="accordionBlocks | stringify('content')"
            :limit="isEditable ? 0 : accordionShowMoreLimit"
            :tracking-scope="accordionsHeading"
          />
        </div>
      </in-view>
    </div>

    <div
      v-if="contentArea.length || (isEditable && contentArea.length)"
      v-edit="'ContentBlocks'"
      class="usp-block-wrapper fade-in"
      :style="{ animationDelay: ( (contentArea.length + 2) * (1 / 8)) + 's' }"
    >
      <navigation-group-block
        v-for="block in contentArea"
        :key="block.contentId"
        v-bind="block"
      />
    </div>
  </div>
</template>

<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import PreambleBlock from '@/vue/blocks/PreambleBlock/preambleBlock'

  export default {
    name: 'PoliciesOverviewPage',
     components: {
      PreambleBlock
    },
    mixins: [pageWithNavigation],
    props: {
      title: {
        type: String,
        default: ""
      },
      preamble: {
        type: String,
        default: ""
      },
      breadcrumbs: {
        type: Array,
        default () {
          return []
        }
      },
      navigatonalBlockTitle: {
        type: String,
        default: ""
      },
      firstNavigatablePages: {
        type: Array,
        default: () => []
      },
      secondNavigatonalBlockTitle: {
        type: String,
        default: ""
      },
      secondNavigatablePages: {
        type: Array,
        default: () => []
      },
      contactblocks: {
        type: Array,
        default () {
          return []
        }
      },
      navigationBlocks: {
        type: Array,
        default () {
          return []
        }
      },
      accordionsHeading: {
        type: String,
        default: ""
      },
      accordionShowMoreLimit: {
        type: Number,
        default: 0
      },
      accordionBlocks: {
        type: Array,
        default () {
          return []
        }
      },
      displayFirstPuffAsPrimary: {
        type: Boolean,
        default: false
      },
      contentArea: {
        type: Array,
        default () {
          return []
        }
      }
    },
    computed: {
      rowClass () {
        const nrOfNavigationBlocks = this.firstNavigatablePages.length
        if(nrOfNavigationBlocks <= 2){
          return "row-1_md-2"
        }
        const rowOfThreeHoles =
          nrOfNavigationBlocks % 3 === 0 ? 0 : 3 - (nrOfNavigationBlocks % 3)
        const rowOfFourHoles =
          nrOfNavigationBlocks % 4 === 0 ? 0 : 4 - (nrOfNavigationBlocks % 4)

        if (rowOfThreeHoles < rowOfFourHoles) {
          return "row-1_lg-3_md-2"
        }

        return "row-1_lg-4_md-2"
      },
      secondRowClass () {
        const nrOfNavigationBlocks = this.secondNavigatablePages.length
        if(nrOfNavigationBlocks <= 2){
          return "row-1_md-2"
        }
        const rowOfThreeHoles =
          nrOfNavigationBlocks % 3 === 0 ? 0 : 3 - (nrOfNavigationBlocks % 3)
        const rowOfFourHoles =
          nrOfNavigationBlocks % 4 === 0 ? 0 : 4 - (nrOfNavigationBlocks % 4)

        if (rowOfThreeHoles < rowOfFourHoles) {
          return "row-1_lg-3_md-2"
        }

        return "row-1_lg-4_md-2"
      }
    }
  }
</script>

<style lang="scss">
  .policies-overview-page {
    .preamble {
      $text-max-width: 57.5rem;

      &__wrapper {
        margin-bottom: 2rem;
        padding: 0;

        @include media-breakpoint-up(md) {
          margin-bottom: 3rem;
        }

        @include media-breakpoint-up(lg) {
          margin-bottom: 3.5rem;
        }

        @include media-breakpoint-up(xl) {
          margin-bottom: 4rem;
        }
      }

      &__heading {
        margin: 1.5rem 0 1rem;
        max-width: $text-max-width;
        color: $color-brown-dark;
      }

      &__text {
        max-width: $text-max-width;
        margin: 1rem 0 0;
        color: $color-brown-dark;
      }
    }

    .section-heading-name {
      margin-bottom: 0.5rem;

      @include media-breakpoint-up(xl) {
        margin-bottom: 1rem;
      }
    }

    .overview-navigation-block__area {
      margin-bottom: 1rem;

      @include media-breakpoint-up(md) {
        margin-bottom: 2rem;
      }

      @include media-breakpoint-up(lg) {
        margin-bottom: 2.5rem;
      }

      @include media-breakpoint-up(xl) {
        margin-bottom: 3rem;
      }
    }

    .contact-block-wrapper {
      @include contactBlock();

      &:first-of-type {
        @include media-breakpoint-down(sm) {
          margin-top: 3.5rem;
        }
      }

      @include media-breakpoint-up(md) {
        margin-top: 4.75rem;
      }

      @include media-breakpoint-up(lg) {
        margin-top: 5.25rem;
      }

      @include media-breakpoint-up(xl) {
        margin-top: 5.75rem;
      }
    }

    .no-margin-bottom {
      margin-bottom: 0;
    }
  }
</style>
